import React, { useState } from 'react';
import { Table, Button } from 'react-bootstrap';
import Pagination from './Pagination'; // Import your Pagination component here
import { useTranslation } from 'react-i18next';

interface userDeviceList {
    id: string;
    name: string;
    nurse_id: string;
    date: string;
}

interface Props {
    deviceList: userDeviceList[];
}

import { TbDeviceIpadX } from 'react-icons/tb';

const DeviceNurseList: React.FC<Props> = ({ deviceList }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const totalPages = Math.ceil(deviceList.length / rowsPerPage);

    const handlePageChange = (page: number) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const currentData = deviceList.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const disablePrevious = currentPage === 1;
    const disableNext = currentPage === totalPages;

    // const totalPages = Math.ceil(deviceList.length / rowsPerPage);

    // const handlePageChange = (page: number) => {
    //     if (page > 0 && page <= totalPages) {
    //         setCurrentPage(page);
    //     }
    // };

    // const currentData = deviceList.slice(
    //     (currentPage - 1) * rowsPerPage,
    //     currentPage * rowsPerPage
    // );

    const { t } = useTranslation();

    const handleRowsPerPageChange = (
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        setRowsPerPage(Number(event.target.value));
        handlePageChange(1); // Reset to first page
    };

    const goToPreviousPage = () => {
        if (!disablePrevious) {
            handlePageChange(currentPage - 1);
        }
    };

    const goToNextPage = () => {
        if (!disableNext) {
            handlePageChange(currentPage + 1);
        }
    };

    const renderPageNumbers = () => {
        const pageNumbers = [];
        const maxVisiblePages = 3;

        if (totalPages <= 6) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(renderPageButton(i));
            }
        } else {
            if (currentPage <= maxVisiblePages) {
                for (let i = 1; i <= maxVisiblePages + 1; i++) {
                    pageNumbers.push(renderPageButton(i));
                }
                pageNumbers.push(renderEllipsis());
                pageNumbers.push(renderPageButton(totalPages));
            } else if (currentPage >= totalPages - maxVisiblePages + 1) {
                pageNumbers.push(renderPageButton(1));
                pageNumbers.push(renderEllipsis());
                for (
                    let i = totalPages - maxVisiblePages + 1;
                    i <= totalPages;
                    i++
                ) {
                    pageNumbers.push(renderPageButton(i));
                }
            } else {
                pageNumbers.push(renderPageButton(1));
                pageNumbers.push(renderEllipsis());

                const startPage = currentPage - 1;
                const endPage = currentPage + 1;

                for (let i = startPage; i <= endPage; i++) {
                    pageNumbers.push(renderPageButton(i));
                }

                pageNumbers.push(renderEllipsis());
                pageNumbers.push(renderPageButton(totalPages));
            }
        }

        return pageNumbers;
    };

    const renderPageButton = (pageNumber: number) => (
        <button
            key={pageNumber}
            className={`mx-1 pagination-padding py-2 border rounded ${pageNumber === currentPage ? '!bg-primary text-white' : 'bg-white text-black'}`}
            onClick={() => handlePageChange(pageNumber)}
        >
            {pageNumber}
        </button>
    );

    const renderEllipsis = () => (
        <span key="ellipsis" className="mx-1 py-2">
            ...
        </span>
    );

    return (
        <div className="bg-white flex flex-col rounded-lg">
            <Table>
                <thead>
                    <tr
                        className="border-none rounded-2xl text-left"
                        style={{ background: '#F9F9F9' }}
                    >
                        <th className="border-none font-bold text-black !normal-case">
                            {t('management.nurse.nurse_name')}
                        </th>
                        <th className="border-none font-bold text-black !normal-case">
                            {t('management.nurse.nurse_id')}
                        </th>
                        <th className="border-none font-bold text-black !normal-case">
                            {t('management.nurse.assigned_date')}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {deviceList.length != 0 ? (
                        <>
                            {currentData.map((userDevice, index) => (
                                <tr className="border-none" key={index}>
                                    <td className="border-none text-black text-left">
                                        {userDevice.name}
                                    </td>
                                    <td className="border-none text-black text-left">
                                        {userDevice.nurse_id}
                                    </td>
                                    <td className="border-none text-black text-left">
                                        {userDevice.date}
                                    </td>
                                </tr>
                            ))}
                        </>
                    ) : (
                        <>
                            <tr className="border-none">
                                <td
                                    className="border-none text-center py-5"
                                    colSpan={3}
                                >
                                    <div className="flex justify-center">
                                        <TbDeviceIpadX
                                            size={40}
                                            className="text-primary"
                                        />
                                    </div>
                                    {t('management.nurse.no_nurse')}
                                </td>
                            </tr>
                        </>
                    )}
                </tbody>
            </Table>

            <div className="pb-3 mt-5 flex justify-between items-center absolute -bottom-28 left-1/2 transform -translate-x-1/2">
                <div className="flex justify-center mx-auto">
                    <button
                        className="btn bg-white text-black text-sm p-1"
                        onClick={goToPreviousPage}
                        disabled={
                            deviceList.length == 0 ||
                            currentPage === 1 ||
                            disablePrevious
                        }
                    >
                        {t('user_management.pagination.previous')}
                    </button>
                    {renderPageNumbers()}
                    <button
                        className="btn bg-white text-black text-sm p-1"
                        onClick={goToNextPage}
                        disabled={
                            deviceList.length == 0 ||
                            currentPage === totalPages ||
                            disableNext
                        }
                    >
                        {t('user_management.pagination.next')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeviceNurseList;
